import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67ba2e4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Retour", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0 mt-3 mt-lg-0" }, "Détails de la composition", -1))
const _hoisted_9 = { class: "composition-details" }
const _hoisted_10 = { class: "info-section mb-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title fw-bold text-dark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode("Informations Générales ")
], -1))
const _hoisted_12 = { class: "info-grid" }
const _hoisted_13 = {
  key: 0,
  class: "info-item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Titre", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 1,
  class: "info-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date de composition", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 2,
  class: "info-item deadline-card"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-danger fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-times me-2" }),
  /*#__PURE__*/_createTextVNode("Date limite de soumission ")
], -1))
const _hoisted_21 = { class: "value text-danger fw-bold fs-5 mb-0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block mt-1" }, " Aucune soumission acceptée après cette date ", -1))
const _hoisted_23 = {
  key: 3,
  class: "info-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type de composition", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "badge-custom" }
const _hoisted_27 = {
  key: 4,
  class: "info-item"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Année Académique", -1))
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "badge-custom" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt me-1" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "info-section mb-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "section-title fw-bold text-dark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-graduation-cap me-2" }),
  /*#__PURE__*/_createTextVNode("Informations Académiques ")
], -1))
const _hoisted_36 = { class: "info-grid-horizontal" }
const _hoisted_37 = {
  key: 0,
  class: "info-item"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Filière", -1))
const _hoisted_39 = { class: "value" }
const _hoisted_40 = {
  key: 1,
  class: "info-item"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Niveau", -1))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = {
  key: 2,
  class: "info-item"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Matière", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = {
  key: 0,
  class: "badge bg-info text-white ms-2"
}
const _hoisted_47 = {
  key: 3,
  class: "info-item"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Professeur", -1))
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  class: "text-muted d-block"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope me-1" }, null, -1))
const _hoisted_53 = {
  key: 2,
  class: "text-muted d-block"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone me-1" }, null, -1))
const _hoisted_55 = {
  key: 0,
  class: "info-section"
}
const _hoisted_56 = { class: "section-title fw-bold text-dark" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle me-2" }, null, -1))
const _hoisted_58 = { class: "badge bg-primary text-white ms-2" }
const _hoisted_59 = {
  key: 0,
  class: "alert alert-warning mb-4 d-flex align-items-center"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-2 fs-4" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Réponses masquées", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = { class: "questions-list" }
const _hoisted_64 = { class: "question-header" }
const _hoisted_65 = { class: "question-number" }
const _hoisted_66 = { class: "number-badge" }
const _hoisted_67 = { class: "question-content-wrapper flex-grow-1" }
const _hoisted_68 = { class: "question-text" }
const _hoisted_69 = {
  key: 0,
  class: "propositions-list"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "propositions-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ul me-2" }),
  /*#__PURE__*/_createTextVNode("Choix de réponses ")
], -1))
const _hoisted_71 = { class: "propositions-items" }
const _hoisted_72 = { class: "proposition-letter" }
const _hoisted_73 = { class: "proposition-content" }
const _hoisted_74 = {
  key: 0,
  class: "correct-indicator"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 1,
  class: "reponse-attendue"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reponse-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb me-2" }),
  /*#__PURE__*/_createTextVNode("Réponse attendue ")
], -1))
const _hoisted_79 = { class: "reponse-content" }
const _hoisted_80 = {
  key: 2,
  class: "reponse-masquee"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reponse-header text-muted" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock me-2" }),
  /*#__PURE__*/_createTextVNode("Réponse attendue ")
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reponse-content-masque" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye-slash me-2" }),
  /*#__PURE__*/_createTextVNode(" Les réponses seront visibles après la date limite de soumission ")
], -1))
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-compositions",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_ctx.composition?.titre)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.composition?.titre), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.dateComposition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.format_date_only(_ctx.composition?.dateComposition)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.dateFinSoumission)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.format_date_only(_ctx.composition?.dateFinSoumission)), 1),
                      _hoisted_22
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.type || _ctx.composition?.typeComposition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString((_ctx.composition?.type || _ctx.composition?.typeComposition) === 'QCM' ? 'QCM' : 'Questions/Réponses'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.annee)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("p", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(_ctx.composition?.annee.libelle), 1)
                        ]),
                        _hoisted_32,
                        _createElementVNode("small", _hoisted_33, " Du " + _toDisplayString(_ctx.format_date_only(_ctx.composition?.annee.dateDebut)) + " au " + _toDisplayString(_ctx.format_date_only(_ctx.composition?.annee.dateFin)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                (_ctx.composition?.filiereNiveauMatiere?.filiere)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.composition?.filiereNiveauMatiere.filiere.libelle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.filiereNiveauMatiere?.niveau)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.composition?.filiereNiveauMatiere.niveau.libelle), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.filiereNiveauMatiere?.matiere)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("p", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.composition?.filiereNiveauMatiere.matiere.libelle) + " ", 1),
                        (_ctx.composition?.filiereNiveauMatiere.coefficient)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Coef. " + _toDisplayString(_ctx.composition?.filiereNiveauMatiere.coefficient), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.composition?.professeur)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("p", _hoisted_49, [
                        _createElementVNode("strong", null, _toDisplayString(`${_ctx.composition?.professeur.nom} ${_ctx.composition?.professeur.prenom}`), 1),
                        (_ctx.composition?.professeur.email || _ctx.composition?.professeur.npi)
                          ? (_openBlock(), _createElementBlock("br", _hoisted_50))
                          : _createCommentVNode("", true),
                        (_ctx.composition?.professeur.email)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_51, [
                              _hoisted_52,
                              _createTextVNode(_toDisplayString(_ctx.composition?.professeur.email), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.composition?.professeur.npi)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_53, [
                              _hoisted_54,
                              _createTextVNode(_toDisplayString(_ctx.composition?.professeur.npi), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.composition?.compoQuestions && _ctx.composition?.compoQuestions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("h5", _hoisted_56, [
                    _hoisted_57,
                    _createTextVNode("Questions "),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.composition?.compoQuestions.length), 1)
                  ]),
                  (!_ctx.dateExpire)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", null, [
                          _hoisted_61,
                          _hoisted_62,
                          _createElementVNode("small", null, [
                            _createTextVNode("Les bonnes réponses seront visibles après la date limite de soumission : "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.format_date_only(_ctx.composition?.dateFinSoumission)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.composition?.compoQuestions, (compoQuestion, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "question-card"
                      }, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString(index + 1), 1)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("p", _hoisted_68, _toDisplayString(compoQuestion.question?.contenu), 1),
                            (compoQuestion.question?.propositions && compoQuestion.question.propositions.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                  _hoisted_70,
                                  _createElementVNode("div", _hoisted_71, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compoQuestion.question.propositions, (proposition, propIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: propIndex,
                                        class: _normalizeClass(["proposition-item", { 'correct-answer': _ctx.dateExpire && proposition.estLaBonneReponse }])
                                      }, [
                                        _createElementVNode("div", _hoisted_72, _toDisplayString(String.fromCharCode(65 + propIndex)), 1),
                                        _createElementVNode("div", _hoisted_73, _toDisplayString(proposition.contenu), 1),
                                        (_ctx.dateExpire && proposition.estLaBonneReponse)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                                          : _createCommentVNode("", true)
                                      ], 2))
                                    }), 128))
                                  ])
                                ]))
                              : (_ctx.dateExpire && compoQuestion.question?.reponse)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createElementVNode("div", _hoisted_79, _toDisplayString(compoQuestion.question.reponse), 1)
                                  ]))
                                : (!_ctx.dateExpire && compoQuestion.question?.reponse)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, _hoisted_83))
                                  : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}